import React, { FC, useEffect } from 'react';
import s from './Overlay.scss';
import { Picture } from '@wix/wix-vod-shared/dist/src/common/components/picture';
import { useStyles } from '@wix/tpa-settings/react';
import stylesParams from '../../../../../../stylesParams';
import { PlayButton } from '../../../../common/components/PlayButton/PlayButton';
import { Button } from '../../../../common/components/Button/Button';
import { useOverlayProps } from '../../../../hooks/useOverlayProps';

const useOverlaySettings = () => {
  const styles = useStyles();
  const showTitle = styles.get(stylesParams.showTitleForMainItem);

  const opacity = styles.get(stylesParams.mainItemOverlayOpacity) / 100;
  return { showTitle, opacity };
};

export const Overlay: FC = () => {
  const { coverUrl, title, playButtonText, paidButton, visible } =
    useOverlayProps();

  const { showTitle, opacity } = useOverlaySettings();

  if (!visible) {
    return null;
  }

  return (
    <div className={s.root}>
      {coverUrl && (
        <Picture
          src={coverUrl}
          breakpoints={[
            {
              min: 0,
              width: 768,
              height: 432,
            },
          ]}
        />
      )}
      <div
        className={s.content}
        style={{
          backgroundColor: `rgba(0,0,0,${opacity})`,
        }}
      >
        {showTitle ? (
          <h3 className={s.title} data-hook="classic-overlay-title">
            {title}
          </h3>
        ) : null}
        <div className={s.buttons}>
          {playButtonText && <PlayButton>{playButtonText}</PlayButton>}
          {paidButton && (
            <Button
              data-hook="classic-overlay-paid-button"
              onClick={paidButton.handler}
            >
              {paidButton.text}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
